import moment from "moment";
import 'moment/locale/es';

export function formatDate(date) {
    const originalDate = moment(date, 'YYYY-MM-DD');
    const formattedDate = originalDate.format('DD MMMM YYYY');
    return formattedDate;
  }